import { useCallback } from 'react';
import { Search } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';

import { Checkbox, Input, Space } from 'antd';

import { useAppSelector } from '@/hooks/redux';
import { useDebounce } from '@/hooks/useDebounce';
import { coursesApi, Params, ModulesParams } from '@/services/course';

const ModulesFilters = () => {
  const { hash } = useParams<{ hash: string }>();
  const [fetchModulesWithFilters, modulesParams] = coursesApi.endpoints.getModules.useLazyQuerySubscription();
  const { debounce } = useDebounce();
  const user = useAppSelector(state => state.auth.user);

  const { params } = modulesParams as ModulesParams;

  const toggleWithFiles = () => {
    handleFetchModules({ ...params, hasFile: !params?.hasFile ? true : undefined });
  };

  const toggleSavedLessons = () => {
    handleFetchModules({ ...params, hasSavedLessons: !params?.hasSavedLessons ? true : undefined });
  };

  const handleSearch = (event: React.ChangeEvent<{ value: string }>) => {
    debounce(() => {
      handleFetchModules({ search: event.target.value || undefined });
    }, 500);
  };

  const handleFetchModules = useCallback(
    (params: Params) => {
      fetchModulesWithFilters({ courseHash: hash, params });
    },
    [fetchModulesWithFilters, hash]
  );
  return (
    <Space direction='horizontal' size={32}>
      <Input
        disabled={params?.hasFile || params?.hasSavedLessons}
        size='large'
        placeholder='Procurar aula'
        prefix={<Search size={12} style={{ marginRight: 8 }} />}
        onChange={handleSearch}
        style={{ marginTop: 2, marginLeft: 2 }}
      />
      <Checkbox disabled={!!params?.search || params?.hasSavedLessons} onChange={toggleWithFiles}>
        Com Anexos
      </Checkbox>
      {user && (
        <Checkbox disabled={!!params?.search || params?.hasFile} onChange={toggleSavedLessons}>
          Aulas Salvas
        </Checkbox>
      )}
    </Space>
  );
};

export default ModulesFilters;
